import { TextField } from '../../fluent';
import React from 'react';
export class NumberField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value ? String(props.value) : props.initialValue
        };
    }
    render() {
        return (React.createElement(TextField, { label: this.props.label, value: this.state.value, required: this.props.required, errorMessage: this.state.errorMessage, maxLength: this.props.maxLength, disabled: this.props.disabled, borderless: this.props.borderless || false, onChange: (_, value) => this._onChange(value), onClick: this.props.onClick, onRenderPrefix: this.props.onRenderPrefix }));
    }
    componentWillReceiveProps(nextProps) {
        if (isNaN(Number(nextProps.value)) || nextProps.value === 0) {
            this.setState({ value: this.props.initialValue });
        }
        else {
            this.setState({ value: String(nextProps.value) });
        }
        this.setState({ errorMessage: nextProps.errorMessage });
    }
    _onChange(value) {
        value = value.split('').filter(o => !isNaN(Number(o))).join('');
        this.setState({ value });
        if (this.props.onChanged) {
            this.props.onChanged(Number(value));
        }
    }
}
